export const FILE_STORAGE_URL = "https://storage.googleapis.com/c9h-cannes-demo";
export const FIRST_LOADER_MIN_TIME = 3000;
